import axios from "axios";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { BASE_URL } from "../config";

const Register = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();
    setErrors({}); // Clear previous errors
    try {
      await axios.get("https://api.softmri.com/sanctum/csrf-cookie", {
        withCredentials: true,
      });

      const response = await axios.post(
        `${BASE_URL}/register`,
        {
          name,
          email,
          password,
        },
        { withCredentials: true }
      );

      if (response.status === 201) {
        localStorage.setItem("token", response.data.token);
        alert("Registration successful!");
        navigate("/dashboard");
      }
    } catch (err) {
      console.error(err.response?.data);
      if (err.response?.status === 422) {
        // Laravel Validation error
        setErrors(err.response.data.errors);
      } else {
        alert("Registration failed");
      }
    }
  };

  return (
    <div className="container-xxl">
      <div className="row vh-100 d-flex justify-content-center">
        <div className="col-12 align-self-center">
          <div className="card-body">
            <div className="row">
              <div className="col-lg-4 mx-auto">
                <div className="card">
                  <div className="card-body p-0 bg-black auth-header-box rounded-top">
                    <div className="text-center p-3">
                      <Link to="/" className="logo logo-admin">
                        <img
                          src="/assets/images/logo-sm.png"
                          height="50"
                          alt="logo"
                          className="auth-logo"
                        />
                      </Link>
                      <h4 className="mt-3 mb-1 fw-semibold text-white fs-18">
                        Let's Get Started Rizz
                      </h4>
                      <p className="text-muted fw-medium mb-0">
                        Sign uP to continue to MaxiRi Tech.
                      </p>
                    </div>
                  </div>
                  <div className="card-body pt-0">
                    <form className="my-4" onSubmit={handleRegister}>
                      <div className="form-group mb-2">
                        <label className="form-label" htmlFor="name">
                          Username
                        </label>
                        <input
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                          type="text"
                          className="form-control"
                          id="name"
                          name="name"
                          placeholder="Enter username"
                        />
                        {errors.name && (
                          <small className="text-danger">{errors.name[0]}</small>
                        )}
                      </div>

                      <div className="form-group mb-2">
                        <label className="form-label" htmlFor="email">
                          Email
                        </label>
                        <input
                          value={email}
                          type="email"
                          onChange={(e) => setEmail(e.target.value)}
                          className="form-control"
                          name="email"
                          id="email"
                          placeholder="Enter email"
                        />
                        {errors.email && (
                          <small className="text-danger">{errors.email[0]}</small>
                        )}
                      </div>

                      <div className="form-group mb-2">
                        <label className="form-label" htmlFor="password">
                          Password
                        </label>
                        <input
                          value={password}
                          type="password"
                          onChange={(e) => setPassword(e.target.value)}
                          className="form-control"
                          name="password"
                          id="password"
                          placeholder="Enter password"
                        />
                        {errors.password && (
                          <small className="text-danger">{errors.password[0]}</small>
                        )}
                      </div>

                      <div className="form-group mb-0 row">
                        <div className="col-12">
                          <div className="d-grid mt-3">
                            <button className="btn btn-primary" type="submit">
                              Register{" "}
                              <i className="fas fa-sign-in-alt ms-1"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                    <div className="text-center mb-2">
                      <p className="text-muted">
                        Already have an account?{" "}
                        <Link to="/" className="text-primary ms-2">
                          Login here
                        </Link>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
